export default "__VITE_ASSET__Dx2SMtBZ__"